import React from 'react';
import { useIntl } from 'umi';
import './index.scss';

export default function GPTAnalysisTarget(props: any) {
  const { defaultValue } = props;
  const { promptInfo } = defaultValue || {};
  const { formatMessage } = useIntl();

  return (
    <div className="dbo-gpt-analysis-target-wrapper">
      <div className="prompt-preview">
        {promptInfo?.prompt || formatMessage({ id: 'None-1' })}
      </div>
    </div>
  );
}
